import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import ServiceDetail from "../views/ServiceDetail";

export default function Services() {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  useEffect(() => {
    if (
      appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<ServiceDetail serviceSlug={appContext.navSubItem} />);
    } else if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<ServicesLanding />);
    } else {
      setView(null);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
